import { render, staticRenderFns } from "./AppAnnotationAssessmentRoot.vue?vue&type=template&id=f2061a5c&scoped=true"
import script from "./AppAnnotationAssessmentRoot.vue?vue&type=script&lang=ts"
export * from "./AppAnnotationAssessmentRoot.vue?vue&type=script&lang=ts"
import style0 from "./AppAnnotationAssessmentRoot.vue?vue&type=style&index=0&id=f2061a5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2061a5c",
  null
  
)

export default component.exports